import styled from 'styled-components';
import { QUALITY_MARK_ASPECT_RATIO } from 'config/config';
import { Table } from '../../../../../ui';

export const EditableProductName = styled.span`
  cursor: pointer;
  color: ${(props) => props.theme.primaryColor};

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledOrderItems = styled(Table)`
  .ant-table-container {
    display: flex;
    justify-content: center;
    align-items: center;

    .white {
      background-color: ${(props) => props.theme.white} !important;
    }

    .ant-table-content {
      width: 100%;
      border: 1px solid ${(props) => props.theme.borderTable};
      border-radius: 10px;

      .ant-table-thead {
        max-height: 20px;

        th {
          border-bottom: 1px solid ${(props) => props.theme.borderTable} !important;
        }

        .ant-table-cell {
          padding: 10px 20px;
          font-weight: 400;
          color: ${(props) => props.theme.stepInactiveColor};
        }

        .ant-table-cell::before {
          background-color: transparent !important;
        }
      }

      .ant-table-tbody {
        font-family: ${(props) => props.theme.fontText};
        font-size: 14px;

        .ant-table-cell {
          padding: 10px 20px;
          border: 0;
          vertical-align: middle;
        }

        .product-cell {
          display: flex;
          align-items: center;
          gap: 8px;

          .quality-marks {
            display: flex;
            gap: 4px;
            align-items: center;

            .quality-mark {
              width: 20px;
              aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};

              .ant-image {
                display: flex;
                width: 100%;
                height: 100%;

                img {
                  object-fit: contain;
                }
              }
            }
          }
        }

        .ant-form-item {
          margin-bottom: 0;
        }

        .ant-input-number-group-wrapper {
          width: 120px;

          .ant-input-number {
            border: 2px solid ${(props) => props.theme.borderTable};
            border-radius: 5px 0 0 5px;
            border-right: none;
          }

          .ant-input-number-group-addon {
            border: 2px solid ${(props) => props.theme.borderTable};
            border-radius: 0 5px 5px 0;
          }
        }

        .ant-input-number:not(.ant-input-number-in-form-item) {
          width: 120px;
          border: 2px solid ${(props) => props.theme.borderTable};
          border-radius: 5px;
        }

        .delete-item-btn {
          border: none;
          background: transparent;
          color: ${(props) => props.theme.black};
          box-shadow: none;

          &:hover {
            color: ${(props) => props.theme.black};
            background: transparent;
          }
        }
      }
    }
  }

  .ant-table-footer {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    background: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.borderTable};
    border-top: none;
    border-radius: 0 0 10px 10px;

    .table-footer {
      padding: 15px 20px;
      display: flex;
      justify-content: flex-start;

      .add-product-btn {
        background: transparent;
        border: 1px solid ${(props) => props.theme.black};
        border-radius: 5px;
        color: ${(props) => props.theme.black};
        box-shadow: none;

        &:hover {
          background: transparent;
          border-color: ${(props) => props.theme.black};
          color: ${(props) => props.theme.black};
        }
      }
    }
  }

  &:has(.ant-table-footer) {
    .ant-table-container .ant-table-content {
      border-radius: 10px 10px 0 0;
      border-bottom: none;
    }
  }
`;

export const StyledMobileEditList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .edit-card {
    border: 1px solid ${(props) => props.theme.borderTable};
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .edit-card-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;

    &:last-child {
      align-items: center;
    }
  }

  .edit-card-label-value {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;

    .label {
      font-size: 12px;
      color: ${(props) => props.theme.stepInactiveColor};
    }

    &.end {
      text-align: end;
      align-items: flex-end;
    }

    .total {
      font-weight: 600;
    }

    .ant-form-item {
      margin-bottom: 0;
    }

    .ant-input-number-group-wrapper {
      width: 100%;

      .ant-input-number {
        border: 2px solid ${(props) => props.theme.borderTable};
        border-radius: 5px 0 0 5px;
        border-right: none;
      }

      .ant-input-number-group-addon {
        border: 2px solid ${(props) => props.theme.borderTable};
        border-radius: 0 5px 5px 0;
      }
    }

    .ant-input-number:not(.ant-input-number-in-form-item),
    .ant-input-number {
      width: 100%;
      border: 2px solid ${(props) => props.theme.borderTable};
      border-radius: 5px;
    }
  }

  .delete-item-btn {
    border: none;
    background: transparent;
    color: ${(props) => props.theme.black};
    box-shadow: none;
    padding: 0;
    text-decoration: underline;

    &:hover {
      color: ${(props) => props.theme.black};
      background: transparent;
    }
  }

  .add-product-btn {
    background: transparent;
    border: 1px solid ${(props) => props.theme.black};
    border-radius: 5px;
    color: ${(props) => props.theme.black};
    box-shadow: none;
    align-self: flex-start;

    &:hover {
      background: transparent;
      border-color: ${(props) => props.theme.black};
      color: ${(props) => props.theme.black};
    }
  }
`;
